// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filterContainer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: var(--spacing-small);
  padding-bottom: var(--spacing-small);
  padding-right: 0;
  width: 600px;
  font-size: var(--font-size-xx-small);
}

.filterIonSelect {
  justify-content: center;
  align-items: center;
  --padding-start: var(--spacing-xx-small);
  --padding-end: var(--spacing-xx-small);
  --padding-top: 0;
  --padding-bottom: 0;
  --width: auto;
}

.filterIonSelect .popover-content {
  width: auto;
}

.centerContent {
  display: flex;
  justify-content: center;
  align-items: center;
}

ion-select::part(icon) {
  font-size: var(--font-size-xx-small);
  width: var(--icon-size-xx-small);
  height: var(--icon-size-xx-small);
}

.custom-outline {
  border: 1px solid var(--af-border-primary);
  border-radius: var(--af-radius-item);
  padding: var(--spacing-xx-small);
  display: flex;
  align-items: center;
  height: 30px;
  width: auto;
}

.filter-item-title {
  margin-left: var(--spacing-large);
  margin-right: var(--spacing-xx-small);
}

.apply-filter-button {
  opacity: 1;
  width: 120px;
  height: auto;
  border-radius: var(--af-radius-item);
  background-color: white;
  font-size: var(--font-size-xx-small);
  margin-left: var(--spacing-large);
  margin-right: 0;
}

/* Consolidated filter select styles */
.custom-select-popover,
.custom-select-popover-filter,
.custom-select-popover-num-months-years,
.custom-select-popover-year {
  background-color: transparent !important;
  color: white !important;
  border: 1px solid var(--af-border-primary);
  border-radius: var(--af-radius-item);
  height: 30px;
  font-size: var(--font-size-xx-small);
  padding: 0;
  margin: 0;
}

.custom-select-popover-filter {
  width: 70px;
}

.custom-select-popover-num-months-years {
  width: 80px;
}

.custom-select-popover-year {
  width: 70px;
}

option {
  color: black;
}

/*.custom-popover ion-select-popover ion-item {
    font-size: 12px;
    padding: 0;
    margin: 0;
    height: 25px;
}

.custom-popover ion-select-popover ion-radio {
    margin: 0;
    padding: 0;
    height: 25px;
}*/`, "",{"version":3,"sources":["webpack://./src/app/pages/logbooks/components/logbook-templates/drone-logbook-template/drone-logbook-template.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EAEA,iCAAA;EACA,oCAAA;EACA,gBAAA;EAEA,YAAA;EAEA,oCAAA;AAFJ;;AAKA;EACI,uBAAA;EACA,mBAAA;EACA,wCAAA;EACA,sCAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;AAFJ;;AAKA;EACI,WAAA;AAFJ;;AAKA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,oCAAA;EACA,gCAAA;EACA,iCAAA;AAFJ;;AAKA;EACI,0CAAA;EACA,oCAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAFJ;;AAKA;EACI,iCAAA;EACA,qCAAA;AAFJ;;AAKA;EACI,UAAA;EAEA,YAAA;EACA,YAAA;EAEA,oCAAA;EACA,uBAAA;EAEA,oCAAA;EAEA,iCAAA;EACA,eAAA;AANJ;;AASA,sCAAA;AACA;;;;EAII,wCAAA;EACA,uBAAA;EAEA,0CAAA;EACA,oCAAA;EAEA,YAAA;EACA,oCAAA;EACA,UAAA;EACA,SAAA;AARJ;;AAWA;EACI,WAAA;AARJ;;AAWA;EACI,WAAA;AARJ;;AAWA;EACI,WAAA;AARJ;;AAWA;EACI,YAAA;AARJ;;AAWA;;;;;;;;;;;EAAA","sourcesContent":[".filterContainer {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n\r\n    padding-top: var(--spacing-small);\r\n    padding-bottom: var(--spacing-small);\r\n    padding-right: 0;\r\n    \r\n    width: 600px;\r\n\r\n    font-size: var(--font-size-xx-small);\r\n}\r\n\r\n.filterIonSelect {\r\n    justify-content: center;\r\n    align-items: center;\r\n    --padding-start: var(--spacing-xx-small);\r\n    --padding-end: var(--spacing-xx-small);\r\n    --padding-top: 0;\r\n    --padding-bottom: 0;\r\n    --width: auto;\r\n}\r\n\r\n.filterIonSelect .popover-content {\r\n    width: auto;\r\n}\r\n\r\n.centerContent {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\nion-select::part(icon) {\r\n    font-size: var(--font-size-xx-small);\r\n    width: var(--icon-size-xx-small);\r\n    height: var(--icon-size-xx-small);\r\n}\r\n\r\n.custom-outline {\r\n    border: 1px solid var(--af-border-primary);\r\n    border-radius: var(--af-radius-item);\r\n    padding: var(--spacing-xx-small);\r\n    display: flex;\r\n    align-items: center;\r\n    height: 30px;\r\n    width: auto;\r\n}\r\n\r\n.filter-item-title {\r\n    margin-left: var(--spacing-large);\r\n    margin-right: var(--spacing-xx-small);\r\n}\r\n\r\n.apply-filter-button {\r\n    opacity: 1;\r\n\r\n    width: 120px;\r\n    height: auto;\r\n\r\n    border-radius: var(--af-radius-item);\r\n    background-color: white;\r\n\r\n    font-size: var(--font-size-xx-small);\r\n\r\n    margin-left: var(--spacing-large);\r\n    margin-right: 0;\r\n}\r\n\r\n/* Consolidated filter select styles */\r\n.custom-select-popover,\r\n.custom-select-popover-filter,\r\n.custom-select-popover-num-months-years,\r\n.custom-select-popover-year {\r\n    background-color: transparent !important;\r\n    color: white !important;\r\n\r\n    border: 1px solid var(--af-border-primary);\r\n    border-radius: var(--af-radius-item);\r\n\r\n    height: 30px;\r\n    font-size: var(--font-size-xx-small);\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.custom-select-popover-filter {\r\n    width: 70px;\r\n}\r\n\r\n.custom-select-popover-num-months-years {\r\n    width: 80px;\r\n}\r\n\r\n.custom-select-popover-year {\r\n    width: 70px;\r\n}\r\n\r\noption {\r\n    color: black;\r\n}\r\n\r\n/*.custom-popover ion-select-popover ion-item {\r\n    font-size: 12px;\r\n    padding: 0;\r\n    margin: 0;\r\n    height: 25px;\r\n}\r\n\r\n.custom-popover ion-select-popover ion-radio {\r\n    margin: 0;\r\n    padding: 0;\r\n    height: 25px;\r\n}*/\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
